const ADMIN_AUTH_ENDPOINTS = {
    login: "/auth/admin/send",
    sentotp: "/auth/admin/send",
    verifyotp: "/auth/admin/verify",
};

const HR_AUTH_ENDPOINTS = {
    login: "/auth/hr/send",
    sentotp: "/auth/hr/send",
    verifyotp: "/auth/hr/verify",
};

const SPECIALIST_AUTH_ENDPOINTS = {
    login: "/auth/specialist/send",
    sentotp: "/auth/specialist/send",
    verifyotp: "/auth/specialist/verify",
};

const VENDOR_AUTH_ENDPOINTS = {
    login: "/auth/vendor/send",
    sentotp: "/auth/vendor/send",
    verifyotp: "/auth/vendor/verify",
};

export const getAuthEndpoints = (role?: string | null) => {
    if (role === "hr") {
        return HR_AUTH_ENDPOINTS;
    }

    if (role === "vendor") {
        return VENDOR_AUTH_ENDPOINTS;
    }

    if (role === "doctors" || role === "specialist" || role === "specialists") {
        return SPECIALIST_AUTH_ENDPOINTS;
    }

    return ADMIN_AUTH_ENDPOINTS;
};

export const AUTHENDPOINTS = {
    ...ADMIN_AUTH_ENDPOINTS,
    signup: "/auth/user/signup",
    // verifyToken: "/auth/user/verify-token",
}
